import React from 'react';

const ClearIcon = props => {
    return <i className={'icon-close cursor-pointer'} {...props} />;
};

export default ClearIcon;
